document.addEventListener("DOMContentLoaded", function() {  
    function getCheckedCount(selector) {
        return document.querySelectorAll(selector + ':checked').length;
    }
    
    function getTotalCount(selector) {
        return document.querySelectorAll(selector).length;
    }
    
    function calculateProgress(checked, total) {
        return total > 0 ? Math.round((checked / total) * 100) : 0;
    }

      function updateTicks() {
        document.querySelectorAll("[class^='tp-progress-check-']").forEach(el => {
            const classParts = el.className.split("tp-progress-check-")[1].split("-");
            let identifier = classParts.join("-");
            if (!identifier.includes('part')) {
              identifier = identifier + '_'
            }
            let relatedInputs = document.querySelectorAll(`[id^='progress_${identifier}']`);
            let completed = [...relatedInputs].every(input => input.checked);
            el.textContent = completed ? '✔' : '';
        });
    }
    
    function updateProgress() {
        let allChecked = getCheckedCount('.tp-progress-input');
        let allTotal = getTotalCount('.tp-progress-input');
        document.getElementById('all-progress').textContent = `${allChecked} / ${allTotal} (${calculateProgress(allChecked, allTotal)}%)`;
        
        // let weekChecked = getCheckedCount(`[id^='progress_week-${currentWeek}_']`);
        // let weekTotal = getTotalCount(`[id^='progress_week-${currentWeek}_']`);
        // document.getElementById('week-progress').textContent = `${weekChecked} / ${weekTotal} (${calculateProgress(weekChecked, weekTotal)}%)`;
        
        // for (let part = 1; part <= 3; part++) {
        //     let partChecked = getCheckedCount(`[id^='progress_week-${currentWeek}_part-${part}_']`);
        //     let partTotal = getTotalCount(`[id^='progress_week-${currentWeek}_part-${part}_']`);
        //     document.getElementById(`part-${part}-progress`).textContent = `${partChecked} / ${partTotal} (${calculateProgress(partChecked, partTotal)}%)`;
        // }

        updateTicks();
    }
    
    function saveProgress() {
        let progressData = {};
        document.querySelectorAll('.tp-progress-input').forEach(input => {
            progressData[input.id] = input.checked;
        });
        localStorage.setItem('workoutProgress', JSON.stringify(progressData));
    }
    
    function loadProgress() {
        let progressData = JSON.parse(localStorage.getItem('workoutProgress')) || {};
        document.querySelectorAll('.tp-progress-input').forEach(input => {
            input.checked = !!progressData[input.id];
        });
    }
    
    document.querySelectorAll('.tp-progress-input').forEach(input => {
        input.addEventListener('change', function() {
            saveProgress();
            updateProgress();
        });
    });
    
    loadProgress();
    updateProgress();
});